module.exports = __webpack_public_path__ + "static/media/SVG_add_favorite_on.032141fa.svg";